import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["changeDeliveryTimeForm", "dealTermsAndConditions", "deliveryTimeAndButton"];

  declare changeDeliveryTimeFormTarget : HTMLElement
  declare dealTermsAndConditionsTarget : HTMLElement
  declare deliveryTimeAndButtonTargets : HTMLElement[]

  displayDeliveryTimeForm() {
    this.changeDeliveryTimeFormTarget.classList.remove("is-completely-hidden")
    this.deliveryTimeAndButtonTargets.forEach((target) => target.classList.add("is-completely-hidden"))
  }

  toggleDealTermsAndConditions(event: Event) {
    event.preventDefault();
    this.dealTermsAndConditionsTarget.classList.toggle("is-completely-hidden");
  }
}
